import React, { FC, useEffect } from 'react'
import s from './DefaultPageFormat.module.sass'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'
import { Notices } from '@widgets/Common/Notices'
import { GigAssChatOpener } from '@widgets/Common/GigAssist/components/GigAssChatOpener'
import { useAppSelector } from '@app/model/store'
import { useElementFinder } from '@shared/lib/hooks/useElemetFinder'
import useFeatureFlag from '@shared/lib/hooks/useFeatureFlag'

type Props = {
  enabledGigachat?: boolean
  enabledNotices?: boolean
}

const DefaultPageFormat: FC<Props> = ({ enabledGigachat = true, enabledNotices = true }) => {
  const isOpenedGigaAssChat = useAppSelector((store) => store.gigAssist.chatOpen)
  const isOpenedModalFeedback = useAppSelector((store) => store.feedback.opened)
  const isButtonHideAnim = isOpenedGigaAssChat || isOpenedModalFeedback

  const userData = useAppSelector((state) => !!state.global?.user?.data)
  const assistFlag = useFeatureFlag('gigachat')
  const isAssistantActive = (userData || assistFlag) && enabledGigachat

  return (
    <div className={s.wrapper}>
      {isAssistantActive && (
        <div className={s.gigass}>
          <GigAssChatOpener isHideAnim={isButtonHideAnim} mode={'fixed-long'} />
        </div>
      )}

      {enabledNotices && <Notices className={s.notices} />}
    </div>
  )
}

export default DefaultPageFormat
